import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function SiteLayout() {
  const { t, lang } = useI18n();

  useEffect(() => {
    document.title = t("meta.title");
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t("meta.description"));
  }, [t, lang]);

  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900 font-dmsans">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <CookieBanner />
    </div>
  );
}
